import { useCallback } from "react"
import cn from "classnames"

import { CURRENCY } from "utils/constants"
import { Text } from "ui-kit/components-branded/index"
import { Tooltip } from "components"

interface CurrencySelectorProps {
    currency: CURRENCY
    onChange: (currency: CURRENCY) => void
    isTitleCenter?: boolean
    isUsdDisabled?: boolean
    tooltipUsdText?: string
}

interface CurrencySwitcherProps {
    currency: CURRENCY
    onChange: (currency: CURRENCY) => void
    isUsdDisabled?: boolean
    tooltipUsdText?: string
}

interface CurrencySelectorBookingProps {
    currency: CURRENCY
    onChange(currency: CURRENCY): void
    isUsdDisabled?: boolean
    tooltipUsdText?: string
}

interface CurrencySelectorPaymentProps {
    updateCurrency(currency: CURRENCY): void
    currency: CURRENCY
    isTitleCenter?: boolean
    isUsdDisabled?: boolean
    tooltipUsdText?: string
}

export function CurrencySelector({
    currency,
    onChange,
    isTitleCenter = false,
    isUsdDisabled = false,
    tooltipUsdText,
}: CurrencySelectorProps) {
    return (
        <div className="currency-selector mgb-3">
            <Text
                className={cn("mgb-4 is-inline-block", {
                    "currency-selector__title": isTitleCenter,
                })}
                isAccent
            >
                Способ оплаты
            </Text>
            <CurrencySelector.Switcher
                currency={currency}
                onChange={onChange}
                isUsdDisabled={isUsdDisabled}
                tooltipUsdText={tooltipUsdText}
            />
        </div>
    )
}

function Switcher({ currency, onChange, isUsdDisabled, tooltipUsdText }: CurrencySwitcherProps) {
    function handleClickUsdButton() {
        if (isUsdDisabled) return
        onChange(CURRENCY.USD)
    }

    return (
        <div className="currency-selector__buttons-group is-flex">
            <label
                htmlFor="booking-form-currency-RU"
                className={cn(
                    "blm-button button is-borderless currency-selector__button is-fullwidth",
                    {
                        "is-active": currency === CURRENCY.RUB,
                    }
                )}
                onClick={() => onChange(CURRENCY.RUB)}
            >
                <input
                    type="radio"
                    name="currency"
                    value={CURRENCY.RUB}
                    id="booking-form-currency-RU"
                    checked={currency === CURRENCY.RUB}
                    className="currency-selector__input"
                    readOnly
                />
                <Text isAccent className="currency-selector__label">
                    <span className="is-hidden-mobile">Российская карта</span>
                    <span className="is-hidden-tablet">Российский</span>
                </Text>
            </label>
            <Tooltip
                placement="top"
                overlay={tooltipUsdText}
                className={cn({ "tooltip-display-none": !isUsdDisabled })}
            >
                <label
                    htmlFor="booking-form-currency-USD"
                    className={cn(
                        "blm-button button is-borderless currency-selector__button is-fullwidth",
                        {
                            "is-active": currency === CURRENCY.USD,
                        }
                    )}
                    onClick={handleClickUsdButton}
                >
                    <input
                        type="radio"
                        name="currency"
                        value={CURRENCY.USD}
                        id="booking-form-currency-USD"
                        checked={currency === CURRENCY.USD}
                        className="currency-selector__input"
                        disabled={isUsdDisabled}
                        readOnly
                    />
                    <Text isAccent className="currency-selector__label">
                        <span className="is-hidden-mobile">Зарубежная карта</span>
                        <span className="is-hidden-tablet">Зарубежный</span>
                    </Text>
                </label>
            </Tooltip>
        </div>
    )
}

CurrencySelector.Switcher = Switcher

export function CurrencySelectorBooking({
    isUsdDisabled = false,
    currency,
    onChange,
    tooltipUsdText,
}: CurrencySelectorBookingProps) {
    return (
        <CurrencySelector.Switcher
            currency={currency}
            onChange={onChange}
            isUsdDisabled={isUsdDisabled}
            tooltipUsdText={tooltipUsdText}
        />
    )
}

export function CurrencySelectorPayment({
    updateCurrency,
    currency,
    isTitleCenter = false,
    isUsdDisabled = false,
    tooltipUsdText,
}: CurrencySelectorPaymentProps) {
    const onChangeCurrency = useCallback((currency: CURRENCY) => {
        updateCurrency(currency)
    }, [])

    return (
        <CurrencySelector
            onChange={onChangeCurrency}
            currency={currency}
            isTitleCenter={isTitleCenter}
            isUsdDisabled={isUsdDisabled}
            tooltipUsdText={tooltipUsdText}
        />
    )
}
